import React from "react";
import { FaArrowRight } from "react-icons/fa";
import { Link } from "react-router-dom";
import ProjectVisual from "./ProjectVisual";
import ProjectText from "./ProjectText";

function ProjectCard({ project }) {
  return (
    <article className="h-full">
      <Link
        to={`/portfolio/${project.slug}`}
        className="group flex h-full flex-col overflow-hidden rounded-panel border border-line bg-white shadow-panel transition duration-300 ease-smooth hover:border-lineStrong hover:shadow-brand focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-brand motion-reduce:transition-none"
        aria-label={`Découvrir le projet ${project.name}`}
      >
        <div className="aspect-[16/10] overflow-hidden border-b border-line bg-surfaceSoft/40">
          <ProjectVisual project={project} />
        </div>

        <div className="flex flex-1 flex-col p-6 sm:p-7">
          <span className="eyebrow self-start">{project.type}</span>
          <h2 className="text-2xl sm:text-3xl">{project.name}</h2>
          <p className="mt-4 flex-1">
            <ProjectText>{project.shortDescription}</ProjectText>
          </p>

          {project.cardTechnologies.length > 0 ? (
            <div className="mt-5 flex flex-wrap gap-2" aria-label="Technologies utilisées">
              {project.cardTechnologies.map((technology) => (
                <span key={technology} className="skill-pill">
                  {technology}
                </span>
              ))}
            </div>
          ) : null}

          <span className="mt-7 inline-flex items-center self-start text-sm font-semibold text-brandDeep">
            Découvrir le projet
            <FaArrowRight
              className="ml-2 transition-transform duration-300 group-hover:translate-x-0.5 motion-reduce:transition-none"
              aria-hidden="true"
            />
          </span>
        </div>
      </Link>
    </article>
  );
}

export default ProjectCard;
